import { useState } from "react"

const useStepList = (steps) => {

	const [step, setStep] = useState(1)

	function goToStep(newStep) {
		if (newStep < 1 || newStep > steps?.length) {
			return
		}
		setStep(newStep)
	}

	function prevStep() {
		goToStep(step - 1)
	}

	function nextStep() {
		goToStep(step + 1)
	}

	return {
		step,
		goToStep,
		prevStep,
		nextStep,
	}
}

export default useStepList;



